import React, { PureComponent, Fragment } from "react";

import Tabs from "Tabs/TabsComponent";

import _ from "i18n";
import { TTP_API_URL } from "Config";

import { addLandaSize } from "Utils";
import classnames from "classnames";
import styles from "./DisplayAlbum.local.scss";

export default class Content extends PureComponent {
  // renderMedia = media => {
  //   const { language } = this.props;
  //   return (
  //     <div className={styles["list-tile"]}>
  //       <div class={styles["heading"]} />
  //       <div className={styles["title"]}>
  //         {media["title" + language]
  //           ? media["title" + language]
  //           : _("No title in selected language")}
  //       </div>
  //     </div>
  //   );
  // };

  renderSwitch = docType => {
    switch (docType) {
      case "VIDEO":
        return this.renderVideoViewer();
      case "PDF":
      case "PPT":
        return this.renderPDFViewer();
      default:
        break;
    }
  };

  renderViwer = () => {
    const { selectedMedia } = this.props;
    if (selectedMedia) {
      const { fullMediaUrl, webPath, docType } = selectedMedia;
      let path = null;
      if (docType === "IMAGE") {
        path = fullMediaUrl ? fullMediaUrl : TTP_API_URL + "/" + webPath;
      }
      path = path ? addLandaSize(path, 600) : "/img/no-image.png";
      return (
        <div
          className={styles["media-viewer"]}
          style={docType === "IMAGE" ? { backgroundImage: `url(${path})` } : {}}
        >
          {this.renderSwitch(docType)}
        </div>
      );
    } else {
      return null;
    }
  };

  getPDFPathFromPPT(media) {
    const path = media.fullMediaUrl.substring(
      0,
      media.fullMediaUrl.lastIndexOf("/")
    );

    return `${path}/PDF/${media.id}.pdf`;
  }

  renderVideoViewer() {
    const { selectedMedia } = this.props;

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center"
        }}
      >
        <video
          src={selectedMedia.fullMediaUrl}
          controls
          style={{ width: "100%" }}
        />
      </div>
    );
  }

  renderPDFViewer() {
    const { selectedMedia } = this.props;

    const webPath =
      selectedMedia.docType === "PDF"
        ? selectedMedia.fullMediaUrl
        : this.getPDFPathFromPPT(selectedMedia);

    const iframeStyles = {
      width: "100%",
      height: "100%"
    };

    return (
      <iframe
        style={iframeStyles}
        title={selectedMedia.title}
        src={`/pdf-viewer/web/viewer.html?file=${encodeURIComponent(webPath)}`}
      />
    );
  }

  handelClick = media => e => {
    const { setSelectedMedia } = this.props;
    e.preventDefault();
    setSelectedMedia(media);
  };

  renderFetchingMedia = () => {
    return (
      <div>
        <div className={styles["list-tile"]}>
          <div className={styles["heading"]} />
          <div className={styles["title"]} />
        </div>
        <div className={styles["list-tile"]}>
          <div className={styles["heading"]} />
          <div className={styles["title"]} />
        </div>
        <div className={styles["list-tile"]}>
          <div className={styles["heading"]} />
          <div className={styles["title"]} />
        </div>
      </div>
    );
  };

  renderMedia = media => {
    const { language, selectedMedia } = this.props;
    const { preview, fullMediaUrl, webPath, docType } = media;
    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    let path = null;
    if (docType === "IMAGE") {
      path = fullMediaUrl ? fullMediaUrl : TTP_API_URL + "/" + webPath;
    } else if (preview && (preview.fullMediaUrl || preview.webPath)) {
      path = preview.fullMediaUrl
        ? preview.fullMediaUrl
        : TTP_API_URL + "/" + preview.webPath;
    }
    path = path ? addLandaSize(path, 120) : "/img/no-image.png";

    return (
      <div
        className={classnames(
          styles["list-tile"],
          selectedMedia && selectedMedia.id === media.id
            ? styles["selected-tile"]
            : ""
        )}
        onClick={this.handelClick(media)}
      >
        <div
          className={styles["heading"]}
          style={path ? { backgroundImage: `url(${path})` } : {}}
        >
          {docType === "VIDEO" && (
            <div className={styles.play}>
              <img src="/img/play.png" alt="" width="30" />
            </div>
          )}
          {docType === "PPT" && (
            <div className={styles["doc-icon"]}>
              <img src="/img/ppt.png" alt="" width="20" />
            </div>
          )}
          {docType === "PDF" && (
            <div className={styles["doc-icon"]}>
              <img src="/img/pdf.png" alt="" width="20" />
            </div>
          )}
        </div>
        <div className={styles["title"]}>
          {media[titleAttr]
            ? media[titleAttr]
            : _("No title in selected language")}
        </div>
      </div>
    );
  };

  renderMedias = filter => {
    const { currentAlbum, fetching } = this.props;
    if (currentAlbum) {
      let medias = this.props.currentAlbum.medias;
      if (filter === "IMAGE") {
        medias = medias.filter(media => media.docType === "IMAGE");
      } else if (filter === "VIDEO") {
        medias = medias.filter(media => media.docType === "VIDEO");
      } else if (filter === "DOC") {
        medias = medias.filter(
          media => media.docType === "PDF" || media.docType === "PPT"
        );
      }
      return (
        <div>
          {medias.length > 0 && (
            <div>
              <i class="icotam-media" />
              {medias.length + " " + _("Total des medias")}
            </div>
          )}
          <div className="list-view">
            {medias.map(media => this.renderMedia(media))}
            {fetching &&
              currentAlbum.countMedias > medias.length &&
              this.renderFetchingMedia()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const { currentAlbum, language } = this.props;
    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;
    return (
      <Fragment>
        <div className={styles.rmodal__head}>
          {currentAlbum && currentAlbum[titleAttr]
            ? currentAlbum[titleAttr]
            : _("No title in selected language")}
        </div>
        <div className={styles.rmodal__body}>
          <div className={styles.rmodal__left}>{this.renderViwer()}</div>
          <div className={styles.rmodal__right}>
            <Tabs theme="rtheme">
              <div label="tous"> {this.renderMedias("ALL")}</div>
              <div label="image">{this.renderMedias("IMAGE")}</div>
              <div label="video">{this.renderMedias("VIDEO")}</div>
              <div label="doc">{this.renderMedias("DOC")}</div>
            </Tabs>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/DisplayAlbum/Content.js